<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Banner
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.title"
                outlined
                label="Title"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="8">
              <v-textarea
                v-model="form.description"
                outlined
                label="Write your description here"
                prepend-inner-icon="mdi-card-text-outline"
              >
              </v-textarea>
            </v-col>
            <v-col sm="8" v-if="form.link_path !== null">
              <v-text-field
                v-model="form.link_path"
                outlined
                label="Link URL"
                prepend-inner-icon="mdi-link-variant"
              ></v-text-field>
            </v-col>
            <!-- Start date -->
            <!-- <v-col sm="4">
              <v-menu
                v-model="menu_start"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.start_date"
                    label="Start Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.start_date"
                  @input="menu_start = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col sm="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.end_date"
                    label="End Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.end_date"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col> -->
            <v-col sm="4">
              <input
                type="file"
                id="file"
                name="file"
                :ref="`file`"
                @change="onFileChange"
              />
              <v-btn
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="($refs.file.value = null), (image_path = null)"
                >Remove</v-btn
              >

              <div id="preview" v-if="image_path" class="mt-5">
                <label for="">Image Preview</label>
                <br />
                <img
                  :src="image_path"
                  style="height: 30%; width: 30% !important"
                />
              </div>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
            <!-- /Start date -->
            <!-- <v-col sm="12">
              <label for="privacy-policy">Privacy Policy</label>
              <vue-editor
                ref="message"
                v-model="form.descriptions"
                class="form-control"
              />
            </v-col> -->
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Banner
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "BannerIdPage",
  data() {
    return {
      form: {},
      isLoading: false,
      image_path: "",

      menu: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.bannerId;
      axios
        .get(`/banners/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          console.log("form", this.form);

          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },

    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        let banners = await axios.patch(
          `/banners/${this.$route.params.bannerId}`,
          this.form
        );
        this.banners = banners.data.data;
        await this.handleFileUpload();
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      if (this.$refs.file != null) {
        let attachment = this.$refs.file.files[0];
        let formData = new FormData();
        formData.append("id", this.banners.id);
        formData.append("image_path", attachment);
        await axios
          .post("upload_banners_image", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .catch(function (error) {
            console.log(error);
            console.log("FAILURE!!");
          });
      }
    },
    onFileChange() {
      this.warningImageLoader = false;
      this.file = this.$refs.file?.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = (evt) => {
        let img = new Image();
        img.onload = () => {
          this.imageLoader = false;
          this.image_path = URL.createObjectURL(this.file);
          this.imageErrors = "";
        };
        img.src = evt.target.result;
      };

      reader.onerror = (evt) => {
        console.error(evt);
      };
      // this.image_path = URL.createObjectURL(this.file);
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/banners/${this.form.id}`,
          from_name: "BannerIdPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        this.$router.push("/banners");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
